import type { BilingualLabel } from '@nadoutong/contracts';
import type { Locale } from '../../i18n/index.ts';
import type { DocsPlaceholderValues } from './placeholders.ts';
import { substituteDocsPlaceholders } from './placeholders.ts';

/**
 * Pick the document's own localized string. The contract carries `zh`
 * and `en`; this console's locale union is `zh-CN` | `en`.
 */
export function docsLabel(label: BilingualLabel, locale: Locale): string {
  return locale === 'zh-CN' ? label.zh : label.en;
}

export function docsResolvedLabel(
  label: BilingualLabel,
  locale: Locale,
  values: DocsPlaceholderValues,
): string {
  return substituteDocsPlaceholders(docsLabel(label, locale), values);
}
